<template>
  <div class="new-label" :style="{ top: topPosition, right: rightPosition }">
    <span class="new" :class="alignmentClass">New</span>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'

export default defineComponent({
  name: 'NewLabelElement',
  props: {
    topPosition: {
      type: String,
      default: '25px'
    },
    rightPosition: {
      type: String,
      default: '30px'
    },
    alignment: {
      type: String as PropType<'left' | 'right'>,
      default: 'left'
    }
  },
  computed: {
    alignmentClass(): string {
      return this.alignment === 'left' ? 'left' : 'right';
    }
  }
})
</script>


<style lang="scss" scoped>
.new-label {
  display: flex;
  position: absolute;

  .new {
    background: var(--accent-100);
    color: var(--text-light-fixed);
    padding: 3px 6px;
    border-radius: 6px;
    font-size: var(--fs-11);
    font-weight: 600;
    line-height: normal;
    position: relative;
    margin-right: 6px;

    &::before{
      content: "";
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 0;
      height: 0;
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
    }

    &.right {
      margin-left: 0px;
      margin-right: 6px;
      &::before {
        right: -5px;
        border-left: 6px solid var(--accent-100);
      }
    }

    &.left {
      margin-left: 6px;
      margin-right: 0;
      &::before {
        left: -5px;
        border-right: 6px solid var(--accent-100);
      }
    }
  }
}
</style>
